// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"196":"bbf27cfb","693":"2d491942","845":"903ac0ba"}[chunkId] + ".chunk.js";
};